import React, {Component} from 'react';
import classes from './resetPasswordSuccess.module.css';
import {Container, Row, Col, Card, Button} from 'react-bootstrap';

class ResetPasswordSuccess extends Component{
    
    backToLogin=()=>{
        this.props.history.push({
            pathname:'/login'
           });
     }

   render(){
       return(
           <div className = {classes.Background}>
        <Container style={{ padding: '15%' }} fluid>
        <Row className="justify-content-center ">
            <Col md={7}>
                <Card>
                    <Card.Body>
                        <Card.Title className= {`text-center mb-5 ${classes.Title}`}>Reset Password</Card.Title>
                        <Card.Text className = "d-flex justify-content-center mb-4" style={{marginTop:-15}}>
                       Your password has been reset successfully! 
                        </Card.Text>
                        {this.props.role=='CN'?
                        <Row className = "d-flex justify-content-center mb-3">
                            <Button style={{marginTop:15}} variant="warning text-white" className={classes.Button} onClick={()=>this.backToLogin()}>Go to Login</Button>
                        </Row>:null}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </Container>
    </div>
       );
   }
}

export default ResetPasswordSuccess;